/*
 * @Author: wangjiaxin@leedarson.com
 * @Date: 2019-12-02 18:54:05
 * Copyright © Leedarson. All rights reserved.
 */

import { noop as NOOP } from '@root/shared';

/**
 * 实现队列功能，队列的自执行，
 * code demo：Modal.confirm 队列demo
 *
 * const _queue = new Queue(confirm);
 * const props = {id: 'xxxxxxxx', ....};
 * _queue.push(props.id, props);
 */

let _uuid = 0;

class Queue {
  constructor(action, prefix = '') {
    this.prefix = prefix;
    this.queues = {};
    this.queueIds = [];
    this.action = action;
    this.executing = true;
  }

  /**
   * 推入队列
   */
  push(id, props) {
    let queueId = id;
    if (!queueId) {
      _uuid += 1;
      queueId = `${this.prefix}-${_uuid}`;
    }

    if (this.queues[queueId]) {
      return queueId;
    }

    // 首次，直接弹出
    if (this.queueIds.length === 0) {
      this.doAction(queueId, props);
    }

    this.queueIds.push(queueId);
    this.queues[queueId] = props;
    return queueId;
  }

  // 消费当前弹窗任务
  consume(id) {
    if (this.queues[id]) {
      delete this.queues[id];
      this.queueIds.shift();

      // 执行下一个弹窗任务
      if (this.queueIds.length > 0 && this.executing) {
        const currentSequenceId = this.queueIds[0];
        const props = this.queues[currentSequenceId];
        this.doAction(currentSequenceId, props);
      }
    }
  }

  /**
   * 删除队列
   */
  remove(id) {
    if (this.queues[id]) {
      delete this.queues[id];
      const indexOfId = this.queueIds.indexOf(id);
      this.queueIds.splice(indexOfId, 1);
    }
  }

  /**
   * 执行队列工作
   */
  doAction(id, props = NOOP.EMPTY_OBJECT) {
    const { afterClose = NOOP.EMPTY_FUNCTION } = props;
    this.action({
      ...props,
      sequenceId: id,
      afterClose: (closeId) => {
        this.consume(closeId);
        afterClose();
      },
    });
  }

  /**
   * 暂停队列
   */
  pause() {
    this.executing = false;
  }

  /**
   * 重新启动
   */
  start() {
    this.executing = false;
  }

  /**
   * 当前队列
   */
  getLength() {
    return this.queueIds.length;
  }
}

export default Queue;
